import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, IconButton, Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useAuth } from '../../utils/auth';
import { useTransitionNavigate } from '../../lib/navigation/useTransitionNavigate';

const ProtectedLayout: React.FC = () => {
  const navigate = useNavigate();
  const go = useTransitionNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  // Full-screen workspaces bring their own navigation back to the panel.
  const fullScreen = ['/marketing/apple-ads', '/marketing/amazon-ads'].some(path => location.pathname.startsWith(path)) || ['/blogs', '/app'].includes(location.pathname);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {!fullScreen && <AppBar
        position="static"
        color="inherit"
        sx={{
          bgcolor: 'rgba(255, 255, 255, 0.92)',
          color: 'text.primary',
          backdropFilter: 'blur(16px)',
          borderBottom: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 64, sm: 72 } }}>
          {location.pathname !== '/home' && (
            <IconButton
              color="primary"
              onClick={() => go('/home')}
              edge="start"
              sx={{ mr: 2 }}
            >
              <HomeIcon />
            </IconButton>
          )}
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>Flora</Typography>
            <Typography variant="caption" color="text.secondary">Admin workspace</Typography>
          </Box>
          <Button color="primary" variant="outlined" onClick={handleLogout}>
            Logout
          </Button>
        </Toolbar>
      </AppBar>}
      <Box sx={{ flex: 1 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default ProtectedLayout;
